import React from 'react';
import {FeaturesList, Item, SectionHeader} from '../utils/Styled';
import {Trans, useI18next} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import SoonIndicator from '../utils/SoonIndicator';
import {useCases as useCasesList} from '../constants/useCases';
import {MenuLink, Props} from '../utils/types';
import {InternalPageLink} from 'components/links/Pages';

export const UseCases: React.FC<Props> = ({itemClick}) => {
  const {language} = useI18next();

  return (
    <>
      <SectionHeader marginTop="0">
        <Trans>Use Cases</Trans>
      </SectionHeader>
      <FeaturesList>
        {useCasesList.map((item: MenuLink) => (
          <Item key={item.slug}>
            <MenuItemIcon name={item.icon} />
            {item.slug ? (
              <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
                {item.title}
              </InternalPageLink>
            ) : (
              item.title
            )}
            {item.beta && (
              <SoonIndicator>
                <Trans>BETA</Trans>
              </SoonIndicator>
            )}
          </Item>
        ))}
        {(language === 'es' || language === 'ca') && (
          <Item>
            <MenuItemIcon name="legal" />
            <InternalPageLink
              slug="bono-cultural-pasarela-de-pago"
              activeClassName="active"
              onClick={itemClick}>
              <Trans>Bono Cultural</Trans>
            </InternalPageLink>
          </Item>
        )}
      </FeaturesList>
    </>
  );
};
